/**
 * @generated SignedSource<<bbfc786847f42861eb2e6c63027b2d5a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteWebhookSubscriptionInput = {
  id: any;
};
export type RootlyIntegrationDeleteWebhookSubscriptionMutation$variables = {
  input: DeleteWebhookSubscriptionInput;
};
export type RootlyIntegrationDeleteWebhookSubscriptionMutation$data = {
  readonly deleteWebhookSubscription: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type RootlyIntegrationDeleteWebhookSubscriptionMutation = {
  response: RootlyIntegrationDeleteWebhookSubscriptionMutation$data;
  variables: RootlyIntegrationDeleteWebhookSubscriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteWebhookSubscriptionPayload",
    "kind": "LinkedField",
    "name": "deleteWebhookSubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RootlyIntegrationDeleteWebhookSubscriptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RootlyIntegrationDeleteWebhookSubscriptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7187a351db840d908e268437bc74b640",
    "id": null,
    "metadata": {},
    "name": "RootlyIntegrationDeleteWebhookSubscriptionMutation",
    "operationKind": "mutation",
    "text": "mutation RootlyIntegrationDeleteWebhookSubscriptionMutation(\n  $input: DeleteWebhookSubscriptionInput!\n) {\n  deleteWebhookSubscription(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "17c08eef0b74f53a250e8392c0798cd2";

export default node;
